import * as React from 'react';
import { TableCell, TableRowProps, Tooltip } from '@mui/material';
import TableRow from '../../components/table/TableRow';
import { logTableFields } from './logsFieldsConfig';
import { Log } from './logsContext';
import { formatDateTime, formatDateTimeUTC } from '../../utils';

interface LogsDeviceRowPropsTypes {
  serialNumber: string;
  tableRowProps?: TableRowProps;
  log: Log;
  showUTC?: boolean;
}

function LogsDeviceRow(props: LogsDeviceRowPropsTypes) {
  return (
    <TableRow
      data={props.serialNumber}
      storagePrefix="log_drawer"
      tableRowProps={{
        ...(props.tableRowProps || {}),
        'key': props.serialNumber,
      }}
    >
      {
        logTableFields.map((field) => {
          let value = (field && props.log[field]) || '';
          let tooltipTitle = '';

          if (field === 'timestamp' || field === 'received') {
            const rawValue = props.log[field];
            if (props.showUTC) {
              value = formatDateTimeUTC(rawValue);
              tooltipTitle = `Local: ${formatDateTime(rawValue)}`;
            } else {
              value = formatDateTime(rawValue);
              tooltipTitle = `UTC: ${formatDateTimeUTC(rawValue)}`;
            }
          }

          const cellSx = {
            whiteSpace: 'normal!important',
            wordBreak: 'break-word',
            ...(field === 'log' ? { maxWidth: 400 } : {}),
          };

          const cellContent = (
            <TableCell
              key={field}
              align="left"
              sx={cellSx}
            >
              {value}
            </TableCell>
          );

          if (tooltipTitle && (field === 'timestamp' || field === 'received')) {
            return (
              <Tooltip key={field} title={tooltipTitle} arrow>
                {cellContent}
              </Tooltip>
            );
          }

          return cellContent;
        })
      }
    </TableRow >
  );
}

export default LogsDeviceRow;